import { Component } from '@angular/core';

@Component({
  selector: 'app-qcifris24',
  templateUrl: './qcifris24.component.html',
  styleUrl: '../../../../../../../../styles-tabelle-orari.css'
})
export class Qcifris24Component {

}
